import React, { PropsWithChildren } from 'react';

import BrickContentWrapper from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentWrapper';

export const ContentWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <BrickContentWrapper borderRadius="roundedSquare" maxWidth="100%">
      {children}
    </BrickContentWrapper>
  );
};
